import i18n from '@/i18n'

export default (src, library_title, window_library) => new Promise((resolve, reject) => {
    try {
        const script = document.createElement('script')
            script.src = src
            script.onload = () => {
                if (window_library) {
                    if (window_library in window) {
                        resolve(window[window_library])
                    } else {
                        reject(Error(i18n.t('error_by_platform_loading', { platform: library_title || window_library })))
                    }
                } else {
                    resolve()
                }
            }
            script.onerror = () => {
                reject(Error(i18n.t('error_by_platform_loading', { platform: library_title || window_library })))
            }
            script.nonce = document.querySelector('script[nonce]')?.nonce || ''

        document.head.appendChild(script)
    } catch (error) {
        reject(error)
    }
})
